import { getOrderPeriod, getPostingInfo } from "@/functions/billing";
import { calcVat } from "@/functions/calc-functions";
import { formatAmount, formatStringDateOnly } from "@/functions/format-functions";
import { generalError } from "@/functions/system-modal-functions";
import { SettingsContext } from "@/utilities/settings-context";
import { i18n } from "@/utilities/vue-i18n";
import { BaseOrder, InvoiceStatus, IsCandidateOrder, IsPostingOrder } from "@/views/admin-billing/admin-billing-types";
import { Invoices } from "@/views/billing/billing-types";
import { defineComponent, PropType, reactive } from "@vue/composition-api";
import axios from "axios";

export default defineComponent({
    props: {
        invoices: {
            type: Object as PropType<Invoices>,
        },
        vatAmount: {
            type: Number,
            default: 0,
        },
        loaded: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, ctx) {

        const settings = reactive({
            currentInvoiceId: null as unknown as number,
            currentOrders: null as unknown as Array<BaseOrder>,
        });

        const invoices = {} as { [key: number]: Array<BaseOrder> };

        const getInvoiceOrders = async (invoiceId: number) => {

            if (invoices[invoiceId]) {

                return invoices[invoiceId];
            }

            const orders = (await axios.get<Array<BaseOrder>>(SettingsContext.getApiUrl('getInvoiceOrders'), { params: { id: invoiceId } })).data;

            invoices[invoiceId] = orders;

            return orders;
        };

        const chooseInvoice = async (id: number) => {

            if (id === settings.currentInvoiceId) {

                settings.currentInvoiceId = null as unknown as number;

                settings.currentOrders = null as unknown as [];

                return;
            }

            try {

                const orders = await getInvoiceOrders(id);

                settings.currentInvoiceId = id;

                settings.currentOrders = orders;
            }
            catch {
                await generalError(false);
            }
        };

        const invoiceDownload = async (id: number) => {

            const token = (await axios.get<{ token: string; uid: string }>(SettingsContext.getApiUrl('RequestInvoiceFile'), { params: { id } })).data;

            window.open(`${SettingsContext.getApiUrl('getRequestedInvoiceFile')}?id=${id}&uid=${token.uid}&token=${token.token}`, '_blank');
        };


        return {
            settings,

            invoiceDownload,
            chooseInvoice,
            getInvoiceOrders,

            formatStringDateOnly,
            InvoiceStatus,
            formatAmount,
            calcVat,
            IsCandidateOrder,
            IsPostingOrder,
            getPostingInfo,
            getOrderPeriod,

            // props
            // methods
            // computed
        };
    },
})